import { call, put, takeEvery } from 'redux-saga/effects';
import { SEND_CONTACT_FORM } from './formActionTypes';
import { sendMessage } from '../../api/form';
import { setIsFetched, setHasError } from './formActions';
import { FormAction } from '../../interfaces/form/FormAction';

function* formWorker(action: FormAction) {
  try {
    yield call(sendMessage, action.requestPayload);
    yield put(setIsFetched(true));
    yield action.callback();
  } catch (e) {
    yield put(setHasError(true));
  }
}

export function* formWatcher() {
  yield takeEvery(SEND_CONTACT_FORM, formWorker);
}
